import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busonrentinkedgaonchaufla() {



const cardData =
  {
    keyword: 'Bus On Rent in Kedgaon Chaufula',
    heading: 'Sanavi Travels: Bus On Rent in Kedgaon Chaufula',
    headingDescription: 'Sanavi Travels offers Bus On Rent in Kedgaon Chaufula, providing safe, comfortable, and reliable transportation solutions for families, groups, corporate travel, school excursions, weddings, picnics, and outstation journeys. Located at an important highway junction near Pune, Kedgaon Chaufula serves as a major travel point for group movement. Our fleet of well-maintained AC buses, Non-AC buses, mini buses, luxury coaches, and large seating capacity buses ensures smooth rides, ample legroom, and sufficient luggage space for hassle-free travel. With professional and experienced drivers, flexible one-way and round-trip rental packages, transparent pricing with no hidden charges, and 24/7 booking support, bus rental in Kedgaon Chaufula is ideal for local travel, corporate transport, religious tours, sightseeing trips, and long-distance journeys. Choose Sanavi Travels for trusted bus rental services in Kedgaon Chaufula, delivering comfort, safety, punctuality, and a seamless group travel experience.',

    top: 'Top Places to Visit Near Kedgaon Chaufula with Sanavi Travels',


"topPlaces": [
  {
    "title": "Kedgaon Chaufula Junction",
    "description": "Kedgaon Chaufula is a major highway junction near Pune, connecting multiple important routes. It is a busy transit point for travelers, corporate movement, and group travel, making bus rental services highly convenient and practical."
  },
  {
    "title": "Daund City",
    "description": "Daund is located close to Kedgaon Chaufula and is known for its railway junction, commercial markets, and residential areas. Groups often travel by bus for business visits, family functions, and social events."
  },
  {
    "title": "Bhigwan Bird Sanctuary",
    "description": "Bhigwan Bird Sanctuary is a popular picnic and nature destination near Kedgaon Chaufula, especially known for migratory birds and scenic backwaters. Bus rentals are ideal for bird-watching tours, photography trips, and educational outings."
  },
  {
    "title": "Jejuri Khandoba Temple",
    "description": "Jejuri is a famous pilgrimage site frequently visited by devotees traveling from Kedgaon Chaufula. Hiring a bus ensures organized, comfortable, and safe transportation for religious groups."
  },
  {
    "title": "Pune City Attractions",
    "description": "Kedgaon Chaufula provides easy highway connectivity to Pune city, including popular attractions such as Dagdusheth Ganpati, Shaniwar Wada, and shopping hubs, making it suitable for group sightseeing tours."
  },
  {
    "title": "MIDC and Industrial Areas",
    "description": "Several industrial and MIDC zones are accessible from Kedgaon Chaufula. Corporate groups and employees frequently rely on bus rentals for punctual and organized transportation."
  },
  {
    "title": "Agricultural and Rural Areas",
    "description": "The surrounding region of Kedgaon Chaufula features agricultural land and village routes, often explored during school excursions, rural exposure tours, and educational trips."
  },
  {
    "title": "Local Picnic Spots",
    "description": "Small picnic locations, open spaces, and riverside areas near Kedgaon Chaufula attract families and social groups looking for short leisure trips."
  },
  {
    "title": "Wedding Venues Near Kedgaon",
    "description": "Many wedding halls, banquet lawns, and marriage venues around Kedgaon Chaufula depend on bus rentals for guest transportation and smooth event coordination."
  },
  {
    "title": "Outstation Travel Routes",
    "description": "Kedgaon Chaufula is well connected to outstation destinations such as Shirdi, Nashik, Solapur, Kolhapur, Mumbai, and Pune, making bus rentals ideal for long-distance group travel."
  }
]
,



"services": [
{
"name": "Bus On Rent in Kedgaon Chaufula",
"description": "Bus On Rent in Kedgaon Chaufula offers spacious, comfortable, and well-maintained buses for families, groups, corporate clients, and tourists. Ideal for weddings, picnics, sightseeing tours, religious trips, and long-distance travel with professional drivers."
},
{
"name": "Bus Hire in Kedgaon Chaufula Pune",
"description": "Bus Hire in Kedgaon Chaufula Pune provides flexible and reliable bus rental options for group travel, corporate outings, school tours, and family functions with punctual service."
},
{
"name": "AC Bus Rental Kedgaon Chaufula",
"description": "AC Bus Rental Kedgaon Chaufula ensures a cool, comfortable, and refreshing travel experience with fully air-conditioned interiors, comfortable seating, and smooth rides."
},
{
"name": "Non AC Bus Hire Kedgaon",
"description": "Non AC Bus Hire Kedgaon offers budget-friendly transportation suitable for short-distance travel, rural routes, school trips, and local group journeys."
},
{
"name": "Luxury Bus on Rent Kedgaon Chaufula",
"description": "Luxury Bus on Rent Kedgaon Chaufula delivers premium travel experiences with modern interiors, spacious seating, and enhanced comfort for weddings and corporate events."
},
{
"name": "Mini Bus Rental Kedgaon Chaufula",
"description": "Mini Bus Rental Kedgaon Chaufula is ideal for small groups, family gatherings, local events, and short-distance travel with economical pricing."
},
{
"name": "32 Seater Bus on Rent Kedgaon",
"description": "32 Seater Bus on Rent Kedgaon is suitable for medium-sized groups such as school excursions, office outings, and social gatherings, offering ample seating and luggage space."
},
{
"name": "35 Seater Bus Hire Kedgaon",
"description": "35 Seater Bus Hire Kedgaon provides comfortable and spacious seating arrangements for large group travel, weddings, and long-distance journeys."
},
{
"name": "Bus on Rent Kedgaon for Wedding",
"description": "Bus on Rent Kedgaon for Wedding ensures organized, timely, and comfortable transportation for wedding guests and family members attending marriage ceremonies."
},
{
"name": "Bus Hire Kedgaon for Corporate Travel",
"description": "Bus Hire Kedgaon for Corporate Travel supports employee transportation, meetings, conferences, factory visits, and corporate events with professional service."
},
{
"name": "Bus on Rent Kedgaon for Picnic",
"description": "Bus on Rent Kedgaon for Picnic offers safe, affordable, and convenient transportation for school picnics, family outings, and group leisure trips."
},
{
"name": "Bus Rental Kedgaon Chaufula Outstation",
"description": "Bus Rental Kedgaon Chaufula Outstation provides dependable long-distance travel solutions to major cities and tourist destinations with experienced drivers."
},
{
"name": "Bus Hire Kedgaon with Driver",
"description": "Bus Hire Kedgaon with Driver offers chauffeur-driven buses where professional drivers manage routes, traffic, and safety throughout the journey."
},
{
"name": "Affordable Bus Rental Kedgaon",
"description": "Affordable Bus Rental Kedgaon provides cost-effective bus rental services for groups seeking economical travel without compromising comfort or reliability."
},
{
"name": "Best Bus Service Kedgaon Chaufula",
"description": "Best Bus Service Kedgaon Chaufula is trusted for clean buses, courteous drivers, transparent pricing, and customer-focused group transportation services."
}
],
"tableData": [
["Bus On Rent in Kedgaon Chaufula", "Bus Hire in Kedgaon Chaufula Pune"],
["AC Bus Rental Kedgaon Chaufula", "Non AC Bus Hire Kedgaon"],
["Luxury Bus on Rent Kedgaon Chaufula", "Mini Bus Rental Kedgaon Chaufula"],
["32 Seater Bus on Rent Kedgaon", "35 Seater Bus Hire Kedgaon"],
["Wedding Bus Kedgaon", "Corporate Bus Kedgaon"],
["Picnic Bus Kedgaon", "Outstation Bus Kedgaon Chaufula"],
["Bus Hire Kedgaon with Driver", "Affordable Bus Rental Kedgaon"],
["Best Bus Service Kedgaon Chaufula", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Bus On Rent in Kedgaon Chaufula with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers dependable and comfortable bus rental services in Kedgaon Chaufula for family trips, corporate travel, school tours, religious journeys, and group outings."
  },
  {
    "WhyChooseheading": "Spacious and Well-Maintained Buses",
    "WhyChoosedescription": "All buses are clean, air-conditioned where applicable, and regularly serviced to ensure a smooth and pleasant travel experience."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed drivers are familiar with Kedgaon Chaufula and surrounding highway routes, ensuring safe, punctual, and stress-free journeys."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels follows clear and honest pricing policies, including fuel, tolls, and driver allowances with no hidden costs."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, route planning, and travel queries."
  },
  {
    "WhyChooseheading": "Flexible Rental Options",
    "WhyChoosedescription": "We offer hourly, half-day, full-day, and customized bus rental plans based on group size and travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "Every bus is thoroughly cleaned and sanitized before each trip to ensure a hygienic travel environment."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups, disciplined schedules, and dependable service for all bus rentals in Kedgaon Chaufula."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus rental services in Kedgaon Chaufula?',
    answer: 'Yes, Sanavi Travels provides reliable bus rental services in Kedgaon Chaufula for all types of group travel.'
  },
  {
    question: 'How can I book a bus in Kedgaon Chaufula?',
    answer: 'You can easily book a bus through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available for rent in Kedgaon Chaufula?',
    answer: 'We offer mini buses, 32-seater buses, 35-seater buses, luxury buses, AC buses, and Non-AC buses.'
  },
  {
    question: 'Are the drivers experienced with Kedgaon Chaufula routes?',
    answer: 'Yes, our drivers are professional, licensed, and familiar with Kedgaon Chaufula and nearby routes.'
  },
  {
    question: 'Can I choose custom pickup and drop-off locations?',
    answer: 'Absolutely. You can select pickup and drop-off points as per your travel plan.'
  },
  {
    question: 'Is bus service available 24x7 in Kedgaon Chaufula?',
    answer: 'Yes, Sanavi Travels offers round-the-clock bus rental services in Kedgaon Chaufula.'
  },
  {
    question: 'Are buses sanitized before every trip?',
    answer: 'Yes, all buses are cleaned and sanitized before every journey.'
  },
  {
    question: 'What payment options are accepted?',
    answer: 'We accept UPI, debit cards, credit cards, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our support team remains available throughout the trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Dinesh Jagtap',
    feedback: 'We hired a bus from Kedgaon Chaufula for a wedding. The service was punctual and the journey was very comfortable.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Priyanka Shinde',
    feedback: 'Sanavi Travels arranged an AC bus for our picnic trip from Kedgaon Chaufula. Clean bus and excellent coordination.',
    rating: 5
  }
];










  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus on Rent in Kedgaon Chaufula - Sanavi Travels",
  "description": "Sanavi Travels offers bus on rent in Kedgaon Chaufula for weddings, corporate travel, picnics, and outstation journeys. We provide AC and Non-AC buses, luxury buses, mini buses, 32 seater and 35 seater buses with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "190"
  }
};






  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | Bus on Rent in Kedgaon Chaufula | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book bus on rent in Kedgaon Chaufula with Sanavi Travels. AC & Non-AC buses, luxury and mini bus rental for weddings, corporate travel, picnics, and outstation trips with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/212.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Busonrentinkedgaonchaufla;